import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Carousel Tabs",
  fields: {
    ...ThemeConfig,
    tabs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs",
      maxLimit: 8,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          tabLabel: { type: FIELD_TYPES.GALLERY, label: "Tab Label", translatable: true },
          tabContent: {
            type: FIELD_TYPES.NESTED,
            label: "Tab content",
            fields: {
              asset: {
                type: FIELD_TYPES.NESTED,
                label: "Asset",
                fields: {
                  ...AssetFieldsConfig
                }
              }
            }
          }
        }
      }
    }
  }
};
